/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".enum-value-row[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:10px;background-color:#fff;border-radius:8px}.enum-value-row[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{margin-bottom:0}i.fa.fa-remove[_ngcontent-%COMP%]{color:red;cursor:pointer;margin-top:10px;font-size:1em}i.fa.fa-bars[_ngcontent-%COMP%]{color:#999;cursor:pointer;margin-top:10px;font-size:1em}"];
export { styles as styles };
